<template>
  <div>
    <el-dialog title="提示" :visible.sync="dialogVisible" width="590px" class="custom_dialog" @close="closeDialog">
      <div class="content">
        <div class="tip-text">
          <p class="title">登录失败！</p>
          <p class="line-two">当前手机号无对应账号，您可以：</p>
        </div>
      </div>
      <div class="button-main">
        <el-button type="primary" style="margin-top: 16px;width:208px;" @click="toBind">我有账号，前往绑定并登录</el-button>
        <el-button type="primary" style="margin-top: 13px;width:208px;margin-left:0px" @click="toApply">我没有账号，前往申请</el-button>
      </div>
    </el-dialog>
  </div>
</template>
  
  <script>
let resloveFun = (data) => { }
let rejectFun = (data) => { }
export default {
  name: 'UnboundPhone',
  data() {
    return {
      dialogVisible: false,
    }
  },
  methods: {
    showDialog() {
      return new Promise((resolve, reject) => {
        resloveFun = (data) => resolve(data)
        rejectFun = (data) => reject(data)
        this.dialogVisible = true
      })
    },
    toBind() {
      this.dialogVisible = false
      resloveFun({ type: 'toBind' })
    },
    toApply() {
      this.dialogVisible = false
      resloveFun({ type: 'toApply' })
    },
    closeDialog() {
      rejectFun('close')
    }
  }
}
  </script>
  
  <style lang="scss" scoped>
.content {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
.dialog-footer {
  display: flex;
  justify-content: center;
  .operate-mian {
    width: Translate(220px);
    display: flex;
    justify-content: space-between;
    font-size: Translate(14px);
    color: #999999;
    cursor: pointer;
  }
}
::v-deep .custom_my_form {
  .el-form-item {
    .el-form-item__label {
      color: #333333;
      padding: 0 15px 0 0;
    }
  }
}
.tip-text {
  font-size: Translate(16px);
  color: #333333;
  .title {
    font-size: Translate(16px);
    color: #ff1f00;
  }
  .line-two {
    margin-top: Translate(12px);
  }
}
.button-main {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
</style>